import React, { useState, useRef } from "react";
import API_BASE_URL from "../apiConfig";
import ReportPdfBar from "./ReportPdfBar";

export default function BalanceSheetReport() {
  const [from, setFrom] = useState("2025-04-01");
  const [to, setTo] = useState("2026-03-31");
  const [data, setData] = useState(null);
  const printRef = useRef(null);

  const load = async () => {
    const res = await fetch(`${API_BASE_URL}/reports/balance-sheet?from=${from}&to=${to}`);
    setData(await res.json());
  };

  const sum = (arr) => arr.reduce((t, r) => t + Number(r.amount), 0);
  const totalL = data ? sum(data.liabilities) : 0;
  const totalA = data ? sum(data.assets) : 0;

  return (
    <div style={{ maxWidth: 900, margin: "0 auto" }}>
      <div style={{ textAlign: "center", marginBottom: 10 }}>
        <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
        <input type="date" value={to} onChange={(e) => setTo(e.target.value)} style={{ marginLeft: 6 }} />
        <button onClick={load} style={{ marginLeft: 6 }}>Go..</button>
        {data && <ReportPdfBar contentRef={printRef} fileName="BalanceSheet" />}
      </div>
      <div ref={printRef}>
        <h3 style={{ textAlign: "center" }}>Balance Sheet</h3>
        {data && (
          <>
            <table border="1" cellPadding="6" style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th colSpan="3">Liabilities</th>
                  <th colSpan="3">Assets</th>
                </tr>
                <tr>
                  <th>Group</th><th>Name</th><th>Amount</th>
                  <th>Group</th><th>Name</th><th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {Array.from({ length: Math.max(data.liabilities.length, data.assets.length) }).map((_, i) => {
                  const l = data.liabilities[i];
                  const a = data.assets[i];
                  return (
                    <tr key={i}>
                      <td>{l?.groupCode ?? ""}</td><td>{l?.accountName ?? ""}</td><td style={{ textAlign: "right" }}>{l ? l.amount.toFixed(2) : ""}</td>
                      <td>{a?.groupCode ?? ""}</td><td>{a?.accountName ?? ""}</td><td style={{ textAlign: "right" }}>{a ? a.amount.toFixed(2) : ""}</td>
                    </tr>
                  );
                })}
                <tr style={{ fontWeight: "bold" }}>
                  <td colSpan="2"></td><td style={{ textAlign: "right" }}>{totalL.toFixed(2)}</td>
                  <td colSpan="2"></td><td style={{ textAlign: "right" }}>{totalA.toFixed(2)}</td>
                </tr>
              </tbody>
            </table>
            <div style={{ textAlign: "right", color: "red", fontWeight: "bold", marginTop: 6 }}>
              Difference: {(totalA - totalL).toFixed(2)}
            </div>
          </>
        )}
        <p style={{ textAlign: "center", fontStyle: "italic", marginTop: 20 }}>*** End of report ***</p>
      </div>
    </div>
  );
}